import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import { api } from "../../lib/api";
import { useI18n } from "../../context/LanguageContext";
import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Blog() {
  const { t } = useI18n();
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="max-w-7xl mx-auto px-6 md:px-10 pt-36 pb-28" data-testid="blog-page">
        <span className="font-mono-x text-primary text-xs tracking-[0.35em]">/ INSIGHTS</span>
        <h1 className="mt-6 font-heading font-extrabold tracking-tighter text-5xl md:text-6xl">{t("blog.title")}</h1>
        <p className="mt-4 max-w-2xl text-lg text-muted-foreground">{t("blog.subtitle")}</p>

        {posts.length === 0 ? (
          <p className="mt-16 text-muted-foreground">{t("blog.empty")}</p>
        ) : (
          <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p, i) => (
              <motion.div key={p.id} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}>
                <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="group block rounded-2xl border border-border overflow-hidden bg-card/40 h-full">
                  <div className="relative h-48 overflow-hidden">
                    <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-card/70 to-transparent" />
                  </div>
                  <div className="p-6">
                    <div className="flex flex-wrap gap-2 mb-3">
                      {(p.tags || []).map((tag) => <span key={tag} className="font-mono-x text-[10px] tracking-widest text-primary border border-primary/30 rounded-full px-2 py-0.5">{tag}</span>)}
                    </div>
                    <h3 className="font-heading font-bold text-xl leading-tight group-hover:text-primary transition-colors">{p.title}</h3>
                    <p className="mt-2 text-sm text-muted-foreground line-clamp-2">{p.excerpt}</p>
                    <div className="mt-4 flex items-center justify-between text-xs text-muted-foreground">
                      <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {p.read_minutes} {t("blog.read")}</span>
                      <ArrowUpRight className="w-4 h-4 group-hover:text-primary group-hover:rotate-45 transition-all" />
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
